import env from "./envs";

export const URL_AUTH_TOKEN = () => `${env.HOST}/oauth-end/oauth2/token`;
export const CONTACT_US = `${env.SERVICE_URL}/fale-conosco/protocolos`;

export const CHECK_PROTOCOL = (product, protocol) =>
  `${env.SERVICE_URL}/ouvidoria/${product}/protocolo/${protocol}/valido`;
export const OPEN_COMPLAINT_OMBUDSMAN = `${env.SERVICE_URL}/ouvidoria`;
export const GET_OMBUDSMAN_CONFIG = `${env.SERVICE_URL}/ouvidoria/`;
